import {Button} from 'primereact/button'
import {Toolbar} from 'primereact/toolbar'
import {useNavigate} from 'react-router-dom'

interface Props {
    goBack: () => void;
    prevComponent: string;
}

export const BackTopBar: React.FC<Props> = (props) => {
    const navigate = useNavigate();


    const goBackHandler = () => {
        props.goBack();
        navigate(-1)
    }

    return <>
        <Toolbar left={<Button icon={"pi pi-arrow-left"} label={props.prevComponent} onClick={goBackHandler} />} />
    </>


}
